import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { disableDebugTools } from '@angular/platform-browser';
import { HANDOVER_TYPE_HO3_ID } from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { RisksAlertsModel } from 'src/app/interfaces/well-integrity';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SectionTouched } from '../../shared/section-touched.class';

@Component({
  selector: 'app-handover-detail-well-integrity-risks-alerts',
  templateUrl: './handover-detail-well-integrity-risks-alerts.component.html',
  styleUrls: ['./handover-detail-well-integrity-risks-alerts.component.scss'],
  standalone: false,
})
export class HandoverDetailWellIntegrityRisksAlertsComponent
  extends SectionTouched
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() readOnlyContent!: boolean;
  @Input() isEngineerUser!: boolean;
  @Output() isLoading = new EventEmitter<boolean>();

  originalCheckRisksAlerts: RisksAlertsModel[] = [];
  checkRisksAlerts: RisksAlertsModel[] = [];
  changedIndexes: number[] = [];

  constructor(
    public handoverService: HandoverService,
    public dialogService: DialogService,
    public notificationService: NotificationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.retrieveRisksAlerts();
  }

  retrieveRisksAlerts(): void {
    if (this.handover) {
      this.isLoading.emit(true);
      this.handoverService
        .getRisksAlerts(this.handover.handoverId!)
        .subscribe((risksAlerts) => {
          this.checkRisksAlerts = risksAlerts;
          this.checkRisksAlerts.map((checkRisksAlert) => {
            this.originalCheckRisksAlerts.push(
              Object.assign({}, checkRisksAlert)
            );
          });
          this.isLoading.emit(false);
        });
    }
  }

  onCheckRiskAlertChange(riskAlert: RisksAlertsModel, index: number): void {
    this.onSectionTouched('deliveryLocation');
    this.emitPendingChanges(
      !this.riskAlertValuesAreEqual(
        riskAlert,
        this.originalCheckRisksAlerts[index]
      )
    );
    if (!this.changedIndexes.includes(index)) {
      this.changedIndexes.push(index);
    }
  }

  riskAlertValuesAreEqual(
    value1: RisksAlertsModel,
    value2: RisksAlertsModel
  ): boolean {
    return (
      value1.activeSelected === value2.activeSelected &&
      value1.risksAlertsLabel === value2.risksAlertsLabel
    );
  }

  riskAlertDisabled(riskAlert: RisksAlertsModel) {
    let disabled = false;
    if (this.handover?.handoverTypeId == HANDOVER_TYPE_HO3_ID) {
      if (this.isEngineerUser && riskAlert.risksAlertsUserDr == 'operative') {
        disabled = true;
      } else if (
        !this.isEngineerUser &&
        riskAlert.risksAlertsUserDr == 'engineer'
      ) {
        disabled = true;
      }
    }
    return disabled;
  }

  save(): void {
    const postRisksAlerts: RisksAlertsModel[] = [];
    if (this.changedIndexes.length > 0) {
      this.isLoading.emit(true);
      for (const index of this.changedIndexes) {
        if (this.handover) {
          this.checkRisksAlerts[index].handoverId = this.handover.handoverId;
          if (
            this.checkRisksAlerts[index].risksAlertsType == 'deep' &&
            this.checkRisksAlerts[index].risksAlertsLabel
          ) {
            this.checkRisksAlerts[index].risksAlertsLabel = String(
              this.checkRisksAlerts[index].risksAlertsLabel
            );
          }
        }
        postRisksAlerts.push(this.checkRisksAlerts[index]);
      }
      if (postRisksAlerts.length > 0) {
        if (this.handover) {
          this.handoverService
            .saveRisksAlerts(this.handover.handoverId!, postRisksAlerts)
            .subscribe((savedRisksAlerts: RisksAlertsModel[]) => {
              if (savedRisksAlerts) {
                this.notificationService.notify(
                  `Los cambios en Entrega de Locacion se han guardado con éxito.`,
                  true
                );
                this.originalCheckRisksAlerts = [];
                this.emitPendingChanges(false);
                this.retrieveRisksAlerts();
              } else {
                this.notificationService.notify(
                  `Ocurrió un error al grabar los cambios en Entrega de Locacion.`,
                  false
                );
              }
            });
        }
      }
      this.isLoading.emit(false);
    } else {
      return;
    }
  }
}
